module.exports = __webpack_public_path__ + "img/katarina_bedrooms_19.fcb9a584.jpg";